import state from "./moduleCompanyConfigCrudState.js";
import mutations from "./moduleCompanyConfigCrudMutations.js";
import actions from "./moduleCompanyConfigCrudActions.js";
import getters from "./moduleCompanyConfigCrudGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
